import {FrameworkProfileId, FrameworkProfile} from "platformed-client/types";
import {platformedClient} from "..";

export async function get(frameworkProfileId: FrameworkProfileId): Promise<FrameworkProfile> {
  return platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/framework_profiles/{framework_profile_id}",
    {path: {framework_profile_id: frameworkProfileId}},
  );
}
